<template>
  <div :class="['input-single', {error: errors.has(name)}, styleclass]">
      <label class="radio-label">
          <input type="checkbox" v-model="internalValue" :name="name">
          <span v-html="label"></span>
          <template v-if="required">*</template>
          <span class="checkmark"></span>
      </label>
      <span v-if="errors.has(name)" class="error-msg">{{ errors.get(name) }}</span>
  </div>
</template>

<script>

export default {
  inject: [
    'errors'
  ],
  props: {
    value: {
      default: ''
    },
    name: {
      type: [String]
    },
    label: {
      default: null,
      type: [String]
    },
    styleclass: {
      default: ''
    },
    required: {
      default: false
    }
  },

  data () {
    return {
      lazyValue: this.value
    }
  },

  computed: {
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },

  watch: {
    value (val) {
      this.lazyValue = val
    }
  }
}
</script>

<style lang="scss" scoped>
    .input-wrapper {
        &.error {
            input {
                border-color: #c2063b;
            }
        }

        .error-msg {
            color: #c2063b;
            font-size: 15px;
        }
    }
</style>
